module.exports = __webpack_public_path__ + "static/img/back.b80023bb.png";